// X-Api-Key is only sent in local dev when REACT_APP_API_KEY is explicitly set.
// In production all requests use the Entra Bearer token — no hardcoded key fallback.
const DEV_API_KEY = process.env.REACT_APP_API_KEY;

export async function buildAuthHeaders(
  getToken: () => Promise<string>,
  actor?: { email?: string },
  opts?: { requireToken?: boolean }
): Promise<Record<string, string>> {
  const headers: Record<string, string> = {};
  if (DEV_API_KEY) headers["X-Api-Key"] = DEV_API_KEY;
  const email = actor?.email?.trim();
  if (email) headers["X-Actor-Email"] = email;

  // Always attach Bearer for authenticated users. requireToken controls whether a
  // token acquisition failure is fatal (redirect to login) or best-effort (continue).
  try {
    const token = await getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch (e) {
    if (opts?.requireToken) throw e;
  }

  return headers;
}
